import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import VideogameAssetIcon from '@material-ui/icons/VideogameAsset';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { deepOrange, lightBlue,red, teal } from '@material-ui/core/colors';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AssignmentIcon from '@mui/icons-material/Assignment';
// import moment from 'moment'
import IntlMessages from 'util/IntlMessages';
import {ListItemText,ListItemAvatar,Typography, IconButton,ListItem} from '@mui/material';
import {Tooltip} from '@material-ui/core'
import moment from 'moment'


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  blue: {
    color: "#fff",
    backgroundColor: lightBlue[500],
  },
  red: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
  },
  teal: {
    color: theme.palette.getContrastText(teal[500]),
    backgroundColor: teal[500],
  },
  item:{
    padding:"0px 5px !important"
  }
}));

const NotificationItem = ({notification,getEsignering,getEsignerinGA,goToAktivitet,gotoEvent,gotoKampanj,gotoAvtal,
  gotoPersonaterkomst,gotoArande, gottoProjektBoard, gotoDocument, gotoDashboardcomp,dismissThisNotis,
  gotoOrder, gotoProjekt
}) => {
  const classes = useStyles();
  const {Beskrivning, sdate,icon,title,Dismiss} = notification;

  const GetIcon=(icon)=>{
      switch(parseInt(icon)){
        case 1:return <Avatar className={classes.orange}><InfoOutlinedIcon/></Avatar>
        case 2:return <Avatar className={classes.blue}><VisibilityIcon/></Avatar>
        case 3:return <Avatar className={classes.teal}><CheckIcon/></Avatar>
        case 4:return <Avatar className={classes.red}><CloseIcon/></Avatar>
        case 5:return <Avatar className={classes.teal}><VideogameAssetIcon/></Avatar>
        case 6:return <Avatar className={classes.teal}><AlternateEmailIcon/></Avatar>
        case 7:return <Avatar className={classes.teal}><AssignmentIcon/></Avatar>
      }
  }
  const goToEsignering=(id)=>{
    getEsignering(id)
  }
  const goToEsigneringGA=(id)=>{
    getEsignerinGA(id)
  }
  const goToAktivitet1=(id)=>{
    goToAktivitet(id)
  }
  const gotoEvent1=(id)=>{
    gotoEvent(id)
  }
  const gotoKampanj1=(id)=>{
   gotoKampanj()
  }
  const gotoAvtal1=(id)=>{
    gotoAvtal(id)
  }
  const gotoOrder1=(id)=>{
    gotoOrder(id)
  }
  const gotoPerAterkomt1=(id)=>{
    gotoPersonaterkomst(id)
  }
  const gotoArande1=(id)=>{
    gotoArande(id)
  }
  const gottoProjektBoard1=(id, id2)=>{
    gottoProjektBoard(id, id2)
  }
	const gotoProjekt1=(id)=>{
		gotoProjekt(id)	
	}
  const gotoDocument1=(id)=>{
    gotoDocument(id)
  }
  const gotoDashboardcomp1=(id)=>{
    gotoDashboardcomp(id)
  }
  const handledismissThisNotis = (e,notification) => {
    e.stopPropagation()
    dismissThisNotis(notification)
  }
  const goToKort=(notification)=>{
    console.log(notification, 'notification.Source')
    if(parseInt(notification.SourceId) !== 0){
    switch(parseInt(notification.Source)){
      case 1:
        goToEsignering(notification.SourceId)
        break;
      case 100:
        goToEsigneringGA(notification.SourceId)
        break;
      case 2:
        goToAktivitet1(notification.SourceId)
        break;
      case 3:
        gotoEvent1(notification.SourceId)
        break;
      case 4:
        gotoKampanj1(notification.SourceId)
        break;
      case 5:
        gotoPerAterkomt1(notification.SourceId)
        break;
      case 6:
        gotoAvtal1(notification.SourceId)
        break;
      case 7:
        gotoArande1(notification.SourceId)
        break;
      case 8:
        gottoProjektBoard1(notification.SourceId,notification.SourceId2)
        break;
      case 9:
        gotoDocument1(notification.SourceId)
        break;
      case 10:
        gotoDashboardcomp1(notification.SourceId)
        break;
      case 11:
        gotoOrder1(notification.SourceId)
        break;
      case 12:
        gotoProjekt1(notification.SourceId)
        break;
    }
  }
  }
  return (
    <Tooltip placement='left' title={Beskrivning}>
      <Button className="m-0 btn w-100" onClick={()=>goToKort(notification)} style={{textTransform: 'none'}}>
        {/*
        gutters={true}
        */}
      <ListItem disableGutters={true} dense={true}
        secondaryAction={
          <Tooltip title={<IntlMessages id="Notification.Dismiss" />}>
            <IconButton onClick={(e) => handledismissThisNotis(e, notification)}>
              <CloseOutlinedIcon/>
            </IconButton>
          </Tooltip>
        }
      >
        <ListItemAvatar>{GetIcon(icon)}</ListItemAvatar>
        <ListItemText 
        style={{
          marginTop: 4,
          marginBottom: 4,
          marginRight: 35
        }}
        primary={title} 
        secondary={
            <>
              <Typography variant="caption" display="block" style={{whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis"}}>
              {Beskrivning}
              </Typography>
              <span className="meta-date"><small>
                {moment(sdate).format("YYYY-MM-DD HH:mm:ss")}
              </small>
              </span>
            </>
          } 
        />
      </ListItem>
      </Button>
    </Tooltip>
  );
};

export default NotificationItem;
